import Verification from "features/verification/containers/Verification";
import React from "react";

const VerificationComponent = () => {
  return <Verification />;
};

export default VerificationComponent;
